export default "__VITE_ASSET__BrgXxo6r__"